<template>
    <div>
        <b-alert
            variant="success"
            :show="showAlert_success"
            @dismissed="showAlert_success = false"
            >{{ alert_success_message }}</b-alert
        >

        <b-alert
            variant="danger"
            :show="showAlert_error"
            @dismissed="showAlert_error = false"
            >{{ alert_error_message }}</b-alert
        >

        <b-container fluid>
            <h3 class="mt-3 mb-3">Packing Queue</h3>

            <b-card class="mb-3">
                <div class="search_bar ">
                    <b-row>
                        <!-- <b-col cols="2" class="pr-1">
                            <b-form-select
                                size="sm"
                                v-model="search_criteria.status_selected"
                                :options="status_options"
                            />
                        </b-col> -->
                        <b-col cols="3" class="pl-0 pr-1">
                            <b-form-input
                                id="input-small"
                                size="sm"
                                type="text"
                                placeholder="Queue Name"
                                v-model="search_criteria.keyword"
                            ></b-form-input>
                        </b-col>

                        <b-col cols="3" class="pl-0 pr-1">
                            <b-form-input
                                id="input-small"
                                size="sm"
                                type="text"
                                placeholder="Packing Sector"
                                v-model="search_criteria.packing_sector"
                            ></b-form-input>
                        </b-col>
                        <b-col
                            cols="2"
                            class="pl-0 pr-1"
                            v-if="
                                true ||
                                    $store.state.user_obj.permissions.gols_admin
                            "
                        >
                            <b-form-select
                                size="sm"
                                v-model="search_criteria.client_selected"
                                :options="client_options"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col cols="2" class="pl-0 pr-1">
                            <b-form-input
                                id="input-small"
                                size="sm"
                                type="date"
                                v-model="search_criteria.start_at"
                            ></b-form-input>
                        </b-col>
                        <b-col cols="2" class="pl-0 pr-1">
                            <b-form-input
                                id="input-small"
                                size="sm"
                                type="date"
                                v-model="search_criteria.end_at"
                            ></b-form-input>
                        </b-col>

                        <b-col cols="2">
                            <b-form-checkbox
                                id="checkbox-printed"
                                v-model="search_criteria.printed"
                                name="checkbox-printed"
                                value="1"
                                unchecked-value="0"
                            >
                                Printed
                            </b-form-checkbox>
                        </b-col>

                        <b-col
                            cols="2"
                            class="pl-0 pr-1"
                            v-if="
                                true ||
                                    $store.state.user_obj.permissions.gols_admin
                            "
                        >
                            <b-form-select
                                size="sm"
                                v-model="search_criteria.status_selected"
                                :options="status_options"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <!-- <b-col cols="2" class="pr-1">
                            <b-form-select
                                size="sm"
                                v-model="sort_by_col"
                                :options="sort_by_col_options"
                            />
                        </b-col>
                        <b-col cols="2" class="pl-0 pr-1">
                            <b-form-select
                                size="sm"
                                v-model="sort_by_order"
                                :options="sort_by_order_options"
                            />
                        </b-col> -->
                        <b-col class="pl-0 pr-1">
                            <b-button
                                v-if="
                                    checkPermission(
                                        $store.state.user_obj,
                                        'Warehouse Management',
                                        'Packing Queue',
                                        'Search',
                                        true
                                    )
                                "
                                class="btn-action"
                                size="sm"
                                variant="info"
                                @click="onSearch"
                            >
                                <font-awesome-icon
                                    class="mr-1"
                                    icon="search"
                                />Search
                            </b-button>
                            <b-button
                                class="btn-action"
                                size="sm"
                                variant="info"
                                @click="onExport"
                            >
                                Export
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-card>

            <div class="search_bar mb-3">
                <b-row>
                    <b-col class="pr-1">
                        <b-button
                            v-if="
                                checkPermission(
                                    $store.state.user_obj,
                                    'Warehouse Management',
                                    'Packing Queue',
                                    'Download Packing Queue',
                                    true
                                )
                            "
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="bulkDownloadPacking"
                            >Download Packing Queue</b-button
                        >
                    </b-col>
                </b-row>
            </div>
            <strong># of Records: {{ total_rows }}</strong>

            <b-row class="mb-1">
                <b-col cols="1" class="pr-0">
                    <b-form-select
                        size="sm"
                        v-model="sel_table_limit"
                        :options="[50, 100, 200, 500]"
                        @change="getTrackings()"
                    />
                </b-col>
                <b-col class="pr-1">
                    <b-pagination
                        size="sm"
                        :total-rows="total_rows"
                        v-model="currentPage"
                        :per-page="sel_table_limit"
                        @change="onPageChange"
                        :limit="PAGING_LIMIT"
                    ></b-pagination>
                </b-col>
            </b-row>

            <b-table
                responsive
                small
                outlined
                striped
                hover
                :items="items"
                :fields="fields"
                :tbody-tr-class="rowClass"
            >
                <template v-slot:head(chk_box)="data">
                    <b-form-checkbox
                        size="sm"
                        plain
                        id="chkbox_all"
                        value="all"
                        v-model="check_all_rows"
                    ></b-form-checkbox>
                </template>
                <template v-slot:cell(chk_box)="data">
                    <b-form-checkbox
                        size="sm"
                        class="chkbox_row"
                        plain
                        :id="'chkbox_row_' + data.index"
                        v-model="data.item.is_checked"
                    ></b-form-checkbox>
                </template>

                <template v-slot:cell(created_at)="data">
                    <div v-if="data.item.created_at">
                        {{ displayDate(data.item.created_at) }}
                    </div>
                    <div v-if="!data.item.created_at">-</div>
                </template>

                <template v-slot:cell(order_count)="data">
                    {{data.item.trackings.length}}
                </template>

                <template v-slot:cell(queue_name)="data">
                    <div v-if="data.item.queue_name">
                        <router-link
                            :to="{
                                name: 'packing_queue_detail',
                                params: {
                                    packing_queue_id: data.item.id
                                }
                            }"
                        >
                            {{ data.item.queue_name }}
                        </router-link>
                    </div>
                    <div v-if="!data.item.queue_name">-</div>
                </template>

                <template v-slot:cell(printed_by)="data">
                    <div v-if="data.item.printed_by">
                        {{ data.item.printed_by }}
                    </div>
                    <div v-if="!data.item.printed_by">-</div>
                </template>

                <template v-slot:cell(printed_at)="data">
                    <div v-if="data.item.printed_at">
                        {{ data.item.printed_at }}
                    </div>
                    <div v-if="!data.item.printed_at">-</div>
                </template>

                <template v-slot:cell(packing_sectors)="data">
                    <div v-if="data.item.packing_sectors.length > 0">
                        <ul
                            v-for="(item, index) in data.item.packing_sectors"
                            :key="index"
                        >
                            <li>{{ item }}</li>
                        </ul>
                    </div>
                    <div v-if="data.item.packing_sectors.length == 0">-</div>
                </template>

                <template v-slot:cell(client_names)="data">
                    <div v-if="data.item.client_names.length > 0">
                        <ul>
                            <li
                                v-for="(item, index) in data.item.client_names"
                                :key="index"
                            >
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="data.item.client_names.length == 0">-</div>
                </template>

                <template v-slot:cell(docs)="data">
                    <div v-if="data.item.docs.length > 0">
                        <ul v-if="data.item.doc_visible">
                            <li
                                v-for="(item, index) in data.item.docs"
                                :key="index"
                            >
                                {{ item.document_name }}
                            </li>
                        </ul>
                        <a
                            href="#"
                            @click.prevent="toggleDocVisible(data.index)"
                        >
                            {{
                                data.item.doc_visible
                                    ? `Show less`
                                    : `Show ${data.item.docs.length} items`
                            }}
                        </a>
                    </div>
                    <div v-if="data.item.docs.length == 0">-</div>
                </template>

                <template v-slot:cell(trackings)="data">
                    <div v-if="data.item.trackings.length > 0">
                        <ul v-if="data.item.tracking_visible">
                            <li
                                v-for="(item, index) in data.item.trackings"
                                :key="index"
                            >
                                {{ item }}
                            </li>
                        </ul>
                        <a
                            href="#"
                            @click.prevent="toggleTrackingVisible(data.index)"
                        >
                            {{
                                data.item.tracking_visible
                                    ? `Show less`
                                    : `Show ${data.item.trackings.length} items`
                            }}
                        </a>
                    </div>
                    <div v-if="data.item.trackings.length == 0">-</div>
                </template>

                <template v-slot:cell(remark)="data">
                    <div v-if="data.item.remark">
                        {{ data.item.remark }}
                    </div>
                    <div v-if="!data.item.remark">-</div>
                </template>

                <template v-slot:cell(action)="data"> </template>
            </b-table>

            <b-pagination
                size="sm"
                :total-rows="total_rows"
                v-model="currentPage"
                :per-page="sel_table_limit"
                @change="onPageChange"
                :limit="PAGING_LIMIT"
            ></b-pagination>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
    {
        key: "chk_box",
        label: ""
    },
    {
        key: "client_names",
        label: "Client"
    },
    {
        key: "queue_name",
        label: "Packing List Name"
    },
    // {
    //     key: "trackings",
    //     label: "Trackings"
    // },
    {
        key: "created_at",
        label: "Created Date"
    },
    {
        key: "printed_count",
        label: "# of Prints"
    },
    {
        key: "printed_at",
        label: "Printed at"
    },
    {
        key: "printed_by",
        label: "Printed by"
    },
    {
        key: "page_count",
        label: "# of Pages"
    },
    {
        key: "order_count",
        label: "# of Orders"
    },
    {
        key: "packing_sectors",
        label: "Packing Sector"
    },
    {
        key: "docs",
        label: "Documents"
    },
    {
        key: "remark",
        label: "Remark"
    },
    {
        key: "status",
        label: "Status"
    }
];

import global_function from "../mixins/global_function";

export default {
    name: "Trackings",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode
    },
    data() {
        console.log(this.$store.state.user_obj);
        return {
            sel_table_limit: this.TABLE_LIMIT,
            loader_full: false,
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            search_criteria: {
                keyword: "",
                packing_sector: "",
                client_selected: null,
                printed: 0,
                start_at: moment()
                    .subtract(6, "months")
                    .format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD"),
                status_selected: 'active'
            },
            showAlert_success: false,
            alert_success_message: "",

            showAlert_error: false,
            alert_error_message: "",

            search_user_options: [],
            check_all_rows: false,
            client_name: false,
            sort_by_col: "created_at",
            sort_by_order: "DESC",
            sort_by_col_options: [
                {
                    value: "updated_at",
                    text: "Sort by: Last Updated"
                },
                {
                    value: "schedule_date",
                    text: "Sort by: Process Date"
                },
                {
                    value: "packing_print_at",
                    text: "Sort by: Packing Printed"
                },
                {
                    value: "waybill_print_at",
                    text: "Sort by: Waybill Printed"
                },
                {
                    value: "order_number",
                    text: "Sort by: Order#"
                },
                {
                    value: "tracking_number",
                    text: "Sort by: Tracking#"
                },
                {
                    value: "packing_seq",
                    text: "Sort by: Packing Sequence"
                }
            ],
            sort_by_order_options: [
                {
                    value: "DESC",
                    text: "Descending"
                },
                {
                    value: "ASC",
                    text: "Ascending"
                }
            ],
            client_options: [
                {
                    value: null,
                    text: "All Clients"
                }
            ],
            status_options: [
                {
                    value: 'active',
                    text: 'Active'
                },
                {
                    value: 'hold',
                    text: 'Hold'
                }
            ],
        };
    },
    async created() {
        await this.getTrackings();
        await this.getCouriers();

        let clients_response = await this.getClients_old(
            this.$store.state.user_obj
        );
        for (let i in clients_response.clients) {
            this.client_options.push({
                value: clients_response.clients[i].name,
                text:
                    clients_response.clients[i].full_name +
                    " (" +
                    clients_response.clients[i].name +
                    ")"
            });
        }

        this.initialized = true;
    },
    mounted() {
        // $('#summernote').summernote();
        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    watch: {
        // whenever changes, this function will run
        check_all_rows: function(new_val, old_val) {
            // this.check_all_rows = !this.check_all_rows;
            console.log("check_all_rows");
            if (new_val == "all") {
                // Check all
                for (let i in this.items) {
                    this.items[i].is_checked = true;
                }
            } else {
                for (let i in this.items) {
                    this.items[i].is_checked = false;
                }
            }
            console.log(this.items);
        }
    },
    methods: {
        displayDate(d) {
            if (d == "0000-00-00") {
                return "-";
            } else if (d) {
                return moment(d).format("YYYY-MM-DD");
            } else {
                return "-";
            }
        },

        async getTrackings() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_queue_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.sel_table_limit,
                    sort_by_col: this.sort_by_col,
                    sort_by_order: this.sort_by_order,
                    search_criteria: this.search_criteria,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id
                }
            });
            console.log(response);
            this.items = response.data.packing_queues;
            this.total_rows = parseInt(response.data.total_rows);
            // if (response.data.trackings && response.data.trackings.length > 0) {
            //     this.client_name = response.data.trackings[0].client_name;
            // }
            this.loader.hide();
        },

        async getCouriers() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "couriers_get.php",
                data: {}
            });

            this.courier_options = [
                {
                    value: null,
                    text: "All Couriers"
                }
            ];

            for (let i in response.data.couriers) {
                let courier_obj = {
                    value: response.data.couriers[i].short_name,
                    text: response.data.couriers[i].long_name
                };

                this.courier_options.push(courier_obj);
            }
        },

        async onExport() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            this.$http({
            baseURL: `${this.API_HOST}`,
            url: "packing_queue_get.php",
            method: "POST",
            data: {
                offset: 0,
                limit: 999999,
                mode: 'export',
                sort_by_col: this.sort_by_col,
                sort_by_order: this.sort_by_order,
                search_criteria: this.search_criteria,
                client_id: this.$store.state.user_obj.client_id,
                user_id: this.$store.state.user_obj.user_id,
            },
            responseType: "blob" // important
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "packing_queue_report.xlsx");
                document.body.appendChild(link);
                link.click();
                this.loader.hide();
            });
        },

        onSearch() {
            this.table_offset = 0;
            this.getTrackings();
        },

        downloadExcel() {
            let export_url =
                "https://tracking.gols.com.hk/driver/export/gols_tracking_bulk.xlsx";
            window.open(export_url, "_blank");
        },

        onPageChange(page_to_change) {
            this.table_offset = (page_to_change - 1) * this.sel_table_limit;
            this.getTrackings();
        },

        rowClass(item, type) {
            if (!item || type !== "row") return;
            if (item.is_checked) return "table-info";
        },

        async bulkDownloadPacking() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            let checked_items = [];

            for (let i in this.items) {
                let item_tmp = this.items[i];
                // console.log(item_tmp);
                if (item_tmp.is_checked && item_tmp.id && item_tmp.id != "" && item_tmp.status == 'Active') {
                    checked_items.push(item_tmp);
                }
            }

            for (var i = 0; i < checked_items.length; i++) {
                let item = checked_items[i];
                let packing_queue_id = item.id;

                let response = await this.$http({
                    baseURL: `${this.API_HOST}`,
                    url: "packing_queue_download.php",
                    method: "POST",
                    data: {
                        packing_queue_id: packing_queue_id,
                        user_id: this.$store.state.user_obj.user_id
                    },
                    responseType: "blob" // important
                });

                let url = window.URL.createObjectURL(new Blob([response.data]));
                let link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", item.queue_name + ".pdf");
                document.body.appendChild(link);
                link.click();

                let docs =
                    this.items.find(item => item.id == packing_queue_id).docs ||
                    [];
                for (var j = 0; j < docs.length; j++) {
                    let packing_queue_doc_id = docs[j].id;
                    let doc_response = await this.$http({
                        baseURL: `${this.API_HOST}`,
                        url: "packing_queue_doc_download.php",
                        method: "POST",
                        data: {
                            packing_queue_doc_id: packing_queue_doc_id,
                            user_id: this.$store.state.user_obj.user_id
                        },
                        responseType: "blob" // important
                    });

                    let doc_url = window.URL.createObjectURL(
                        new Blob([doc_response.data])
                    );
                    let doc_link = document.createElement("a");
                    doc_link.href = doc_url;
                    let pieces = docs[j].url.split("/");
                    let filename =
                        pieces.length > 0
                            ? pieces[pieces.length - 1]
                            : pieces[0];
                    doc_link.setAttribute("download", filename);
                    document.body.appendChild(doc_link);
                    doc_link.click();
                }
            }

            this.getTrackings();

            this.loader_full.hide();
        },
        toggleTrackingVisible(index) {
            let tmpItems = this.items;
            tmpItems[index].tracking_visible = !(tmpItems[index]
                .tracking_visible
                ? true
                : false);
            this.items = [...tmpItems];
        },
        toggleDocVisible(index) {
            let tmpItems = this.items;
            tmpItems[index].doc_visible = !(tmpItems[index]
                .doc_visible
                ? true
                : false);
            this.items = [...tmpItems];
        },
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PackingQueue.vue